import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';
import * as actions from '../../store/actions';
import { openMessage, openWorkflow, openVersionHistory, openWorkflowStep } from "../../services/legacyDialogService";
import { openCheckInDialog, openUpdateProfileDialog, openDocumentLogDialog } from '../../services/dialogService';

angular.module('webTools').controller('DocumentsCtrl', ['$scope', '$rootScope', '$routeParams', '$location', '$timeout', 'MenuBuilder', 'Columns', 'Auth', 'GridTools', 'ModalWindow', 'Dialog', 'Utility', 'File', '$ngRedux', '$http',
	function ($scope, $rootScope, $routeParams, $location, $timeout, MenuBuilder, Columns, Auth, GridTools, ModalWindow, Dialog, Utility, File, $ngRedux, $http) {
		const state = $ngRedux.getState();

		$scope.kendo = $scope.kendo || {};
		$rootScope.view = 'documents';
		$scope.gridName = 'documentsGrid';

		$scope.store = $ngRedux;

		if (!$routeParams.page) {
			$location.search('page', 1);
			window.history.replaceState({}, '', $location.url());
		}

		if ($routeParams.linkError) {
			ModalWindow.openNotification('The file or folder you are trying to access does not exist <br/> or you do not have the permissions required to view it.');
			$location.search('linkError', null)
		}

		$rootScope.workingFolder = $routeParams.folder ? $routeParams.folder : 'Documents';

		/* eslint-disable  no-useless-escape */
		$scope.currentLocation = $location.url().replace(/page\=\d+/g, '');
		/* eslint-enable  no-useless-escape */

		var unload = null;

		$scope.selectFile = () => {
			if (!unload) {
				unload = $scope.$on('gridLoaded', function () {

					$scope.file = $routeParams.file;
					$scope.fileLink = true;

					var wtObject = _.find($scope.kendo[$scope.gridName]._data, function (ds) { return ds.ID === $scope.file; });

					angular.element('#details-pane').css({ 'display': 'block' })
					$timeout(() => angular.element('#details-pane').css({ 'margin-right': 0 }), 100)
					$scope.detailsPaneIsOpen = true;

					if ($routeParams.preview === '1') {
						var previewObject = {
							id: wtObject.ID,
							version: wtObject.VersionID,
							minor: wtObject.Minor
						}

						$scope.$emit('loadObjectPreview', previewObject);
					}

					$scope.kendo.selectGridItem(wtObject.ID);
					$scope.$apply()
					unload();
				})
			}
		}

		if ($routeParams.file) {
			$scope.selectFile();
		}

		$scope.$on('$routeUpdate', function (e, data) {

			if ($routeParams.file) {
				$scope.selectFile();
			}
			$scope.menuOptions = [];
			if ($routeParams.folder === 'recyclebin') {
				$scope.documentGridOptions.allowSelectFolders = true;
			} else {
				$scope.documentGridOptions.allowSelectFolders = false;
			}

			/* eslint-disable  no-useless-escape */
			if ($scope.currentLocation === $location.url().replace(/page\=\d+/g, '')) {
				$scope.closeDetailsPane();
			} else {
				$scope.closeDetailsPane();
				$rootScope.workingFolder = $routeParams.folder ? $routeParams.folder : 'Documents';
				$scope.selectedObject = {};
				$scope.$broadcast('reloadGrid');
			}

			$scope.currentLocation = $location.url().replace(/page\=\d+/g, '');
		});
		/* eslint-enable  no-useless-escape */

		$scope.webView = function () { return Auth.isWebView() };

		$scope.nodeSelect = function (e) {
			$location.search({ folder: e.sender.dataItem(e.node).id, page: 1 });
		};

		const endpoint = state.app.endpoint;

		$scope.kendo.documentsData = {
			transport: {
				read: {
					url: `${endpoint ? endpoint : ''}/api/Documents/GetDocuments?nocache=` + new Date().getTime(),
					contentType: 'application/json'
				},
				parameterMap: function (data, operation) {

					if (data.sort && data.sort.length > 0) {
						const sort = { sortField: data.sort[0].field, sortDirection: data.sort[0].dir };

						if (operation === 'read') { delete data.sort; data = $.extend(sort, data); }
					}

					data = $.extend({ folderID: $rootScope.workingFolder }, data);

					return data;
				}
			},
			schema: {
				data: function (response) {
					var path = response.Path;
					$scope.$apply(() => {
						switch ($rootScope.workingFolder.toLowerCase()) {
							case 'favorites':
								$scope.breadcrumb = [{ path: 'favorites', breadcrumbName: 'Favorites' }];
								break;
							case 'recyclebin':
								$scope.breadcrumb = [{ path: 'recyclebin', breadcrumbName: 'Recycle Bin' }];
								break;
							default:
								let pathCopy = _.cloneDeep(path);

								pathCopy.forEach(p => {
									p.pathId = p.path;
									p.path = `/documents?folder=${p.path}`;
								})

								const { pathId: workingFolderId, breadcrumbName: workingFolderName } = _.last(pathCopy);
								$ngRedux.dispatch(actions.setWorkingFolder(workingFolderId, workingFolderName, 'Documents', response.Permissions));

								$rootScope.workingFolderName = workingFolderName;

								$scope.breadcrumb = pathCopy;
								break;
						}
					})
					return response.Data;
				},
				total: 'TotalRows'
			},
			serverPaging: true,
			serverSorting: true,
			pageSize: $rootScope.pageSize || 50,
			page: $routeParams.page || 1,
			sort: $scope.gridSort
		};

		$scope.userView = function () { return Columns.isUserView(); };

		$scope.resetColumns = function () {
			$scope.$broadcast('hideGrid');
			Columns.resetColumns($rootScope.workingFolder, function () { $scope.selectedObject = {}; $scope.$broadcast('reloadGrid'); });
		};

		$scope.showFileButton = false;

		$scope.data = {
			breadcrumb: [],
			fileMenuData: [],
			folderMenuData: []
		};

		$scope.rightClickMenu = false;
		$scope.data.showRightClickMenu = function () { $scope.rightClickMenu = true; };
		$scope.hideRightClickMenu = function () { $scope.rightClickMenu = false; };

		$scope.menuOptions = [];
		$scope.selectedItems = [];

		$scope.$on('selectedItemsUpdated', function (e, selectedItems) {

			$scope.selectedItems = selectedItems;
			$scope.showFileButton = selectedItems.length > 0 ? true : false;

			if (selectedItems.length === 0) { $scope.closeDetailsPane(); }

			if ($rootScope.workingFolder.toLowerCase() === 'recyclebin') {
				if (selectedItems.length === 0) {
					$scope.menuOptions = $scope.data.folderMenuData;
				} else {
					$scope.menuOptions = MenuBuilder.getRecycleContextMenu();
				}
			} else if ($rootScope.workingFolder.toLowerCase() === 'favorites') {
				if (selectedItems.length === 0) {
					$scope.menuOptions = [];
				} else {
					$scope.menuOptions = MenuBuilder.getFileContextMenu(selectedItems, $scope.kendo[$scope.gridName]._data);
				}
			} else {
				if (selectedItems.length === 0) {
					$scope.menuOptions = $scope.data.folderMenuData;
				} else {
					$scope.menuOptions = MenuBuilder.getFileContextMenu(selectedItems, $scope.kendo[$scope.gridName]._data);
				}
			}
		});

		$scope.populateFolderMenu = function () {
			if ($rootScope.workingFolder.toLowerCase() === 'recyclebin') {
				$scope.data.folderMenuData = MenuBuilder.getRecycleMenu();
			} else if ($rootScope.workingFolder.toLowerCase() === 'favorites') {
				$scope.data.folderMenuData = [];
			} else {
				$scope.data.folderMenuData = MenuBuilder.getFolderMenu();
				
			}
		}

		$scope.$on('gridLoaded', function (e) {

			// refresh menu options if there are no selected items
			if ($scope.selectedItems.length === 0) {
				$scope.$apply(() => {
					$scope.populateFolderMenu();
					$scope.menuOptions = $scope.data.folderMenuData;
				})
			} else {
				
				$scope.$emit('selectedItemsUpdated', $scope.selectedItems);
				$scope.$apply()
			}
		});

		$scope.$on('launchLegacyDialog', function (e, data) {

			const { key: dialog } = data;

			const fileIds = _.map($scope.selectedItems, _.partialRight(_.pick, ['ID', 'Name', 'Type']));

			var launch = function (legacyDialog) {
				window.launchLegacyDialog(legacyDialog, $scope.selectedItems, $rootScope.workingFolder, '', $scope.kendo[$scope.gridName], Auth.getUsername());
			}

			// Check to see if file is member of a project on delete
			if (dialog === 'delete') {
				File.isInProject(_.map($scope.selectedItems, function (item) { return "'" + item.ID + "'" }).toString()).then(function (returnData) {
					if (returnData === 'true') {
						var m = "";
						if ($scope.selectedItems.length === 1) {
							m = "The selected file is in a project.<br/>Are you sure you want to delete?";
						} else {
							m = "One or more of the selected files are in a project.<br/>Are you sure you want to delete?";
						}
						ModalWindow.openConfirmation(m, function (data) { launch(dialog); });
					} else {
						launch(dialog);
					}
				})
			}
			else if (dialog === 'bravahtml' || dialog === 'updateprofile') {
				window.launchLegacyDialog(dialog, fileIds);
			}
			else { // Call React dialogs

				const packageCallback = () => { $scope.$broadcast('reloadGrid'); }

				switch (dialog) {
					case 'download':
						File.download(fileIds, 'download')
						break;
					case 'checkout':
						File.download(fileIds, 'checkout', packageCallback)
						break;
					case 'undocheckout':
						File.undoCheckout(fileIds, false, packageCallback);
						break;
					case 'quickapprovalworkflow':
						const modalOptions = {
							title: 'Quick Approval Workflow',
							maskClosable: false,
							footer: null,
							responsive: false
						}
						$ngRedux.dispatch(actions.showModal('QUICK_APPROVAL_WORKFLOW', modalOptions, { selectedItems: $scope.selectedItems }));
						break;
					case 'preview':

						let previewObject = {
							id: $scope.selectedItems[0].ID,
							version: $scope.selectedItems[0].Version,
							minor: $scope.selectedItems[0].Minor
						}

						$scope.$emit('loadObjectPreview', previewObject);
						break;
					case 'message':
						const messageOptions = {
							title: `Send Message`,
							width: 1000,
							responsive: true,
							styles: { body: { height: 550 }},
						}
		
						openMessage($scope.selectedItems)
						break;
					case 'workflow':		
						openWorkflow($scope.selectedItems)
						break;
					case 'versionhistory':
						openVersionHistory($scope.selectedItems)
						break;
					case 'task':
						openWorkflowStep($scope.selectedItems)
						break;
					default:
						launch(dialog);
						break;
				}
			}
		});

		$scope.$on('openLinkDialog', function (e, data) {
			const directLink = Utility.getLinkURL($scope.selectedItems[0].ID);
			$ngRedux.dispatch(actions.showModal('DIRECT_LINK', { title: 'Link', footer: null, width: 400 }, { isFolder: false, directLink }));
		});

		$scope.$on('openRenameDialog', function (e, data) {
				$ngRedux.dispatch(actions.showModal('RENAME', { title: 'Rename' }, { dlObject: $scope.selectedItems[0] }));
		});

		$scope.$on('openCheckinDialog', function (e, data) {
			openCheckInDialog({
				selectedItems: $scope.selectedItems,
				currentUser: Auth.getUsername()
			});
		});

		$scope.$on('openUpdateProfileDialog', function (e, data) {
			openUpdateProfileDialog({
				selectedItems: $scope.selectedItems.map(item => ({ ID: item.ID }))
			});
		});

		$scope.$on('openDocumentLogDialog', function (e, data) {
			openDocumentLogDialog({
				objectId: $scope.selectedItems[0].ID,
				userId: Auth.getUsername()
			});
		});

		$scope.$on('launchFolderDialog', function (e, data) {

			const { key: dialog } = data;

			var folderId = $rootScope.workingFolder;

			if (dialog === 'import') {
				// Dialog.openImport();

				const modalOptions = {
					title: `Import to: ${$rootScope.workingFolderName}`,
					width: 1000,
					responsive: true,
					styles: { body: { height: 550 }},
				}

				$ngRedux.dispatch(actions.showModal('IMPORT', modalOptions, { selectedItems: $scope.selectedItems, importFolder: { id: folderId, name: $rootScope.workingFolderName } }));

			} else if (dialog === 'getFolderLink') {
				const directLink = Utility.getLinkURL(folderId);
				$ngRedux.dispatch(actions.showModal('DIRECT_LINK', { title: 'Link', footer: null, width: 400 }, { isFolder: true, directLink }));
			} else if (dialog === 'renameFolder') {

				var pathNode = _.find($scope.breadcrumb, { pathId: folderId });
				let data = { Name: pathNode.breadcrumbName, ID: pathNode.pathId };
	
				$ngRedux.dispatch(actions.showModal('RENAME', { title: 'Rename' }, { dlObject: data }));

			} else if (dialog === 'newfile') {
				const modalOptions = {
				title: 'New Document',
				width: 1000,
				responsive: true,
				styles: {body: { height: 550 }},
				maskClosable: false,
				footer: null
				}
				$ngRedux.dispatch(actions.showModal('NEW_DOCUMENT', modalOptions, { selectedItems: $scope.selectedItems }));
    		} else {
				window.launchLegacyDialog(dialog, '', folderId, '', $scope.kendo[$scope.gridName]._data, Auth.getUsername());
			}
		});

		$scope.closeDialog = function () {
			$scope.kendo.documentsData.page = $scope.currentPage;
			$scope.selectedObject = {};
			$scope.$broadcast('reloadGrid');
		};

		$scope.launchCheckout = function (fileId) {
			window.launchLegacyDialog('alternateCheckout', '', $rootScope.workingFolder, fileId, $scope.kendo[$scope.gridName]._data, Auth.getUsername());
		};

		$scope.getColumns = function () { return Columns.getDocumentColums($rootScope.workingFolder); };

		$scope.documentGridOptions = {
			loadOnInit: true,
			mainGrid: true,
			allowRowSelect: true,
			allowMultiselect: true,
			allowColumnState: true,
			allowSelectFolders: false,
			enableContextMenu: true,
			columnMenu: true,
			sortable: true,
			resizable: true,
			reorderable: true,
			scrollable: true,
			responsive: true,
			pageable: {
				info: true,
				refresh: false
			}
		};

		$scope.$on('gridFolderLinkClicked', function (e, data) {
			if ($rootScope.workingFolder !== 'recyclebin') {
				$scope.$apply(function () { $location.search({ folder: GridTools.getObjectFromGrid(data, $scope.kendo[$scope.gridName]._data).ID, page: 1 }); });
			}
		});

		$scope.detailsPaneIsOpen = false;
		$scope.selectedObject = {};

		$scope.detailsMargin = '-350px';

		$scope.$on('gridItemSelected', function (e, data) {

			var wtObject = GridTools.getObjectFromGrid(data.id, $scope.kendo[$scope.gridName]._data);

			if (data.openDetails) {
				if (!$scope.detailsPaneIsOpen) {
					angular.element('#details-pane').css({ 'display': 'block' })
					$timeout(() => angular.element('#details-pane').css({ 'margin-right': 0 }), 100)
					$scope.detailsPaneIsOpen = true;
					$scope.selectedObject = wtObject;
				} else {
					if (data.id !== wtObject.ID && $scope.detailsPaneIsOpen) {
						$scope.selectedObject = wtObject;
					}
				}
			} else {
				if (data.id !== wtObject.ID && $scope.detailsPaneIsOpen) {
					$scope.selectedObject = wtObject;
				}
			}
			$scope.$apply();
		});

		$scope.closeDetailsPane = function () {
			if ($scope.detailsPaneIsOpen) { angular.element('#details-pane').css({ 'margin-right': '-350px' }) }
			$scope.detailsPaneIsOpen = false;
			$scope.$broadcast('detailsPaneClosed');
		};

		$scope.$on('breadcrumbClicked', function (e, data) {
			$location.search({ folder: data.id, page: 1 })
		});
	}
]);